/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Shot_NumberInputs */



/**
* | output |
* | --- |
* | "Shot #" |
*
* @param {Ccsl_Export_Header_Shot_NumberInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_shot_number = /** @type {((inputs?: Ccsl_Export_Header_Shot_NumberInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Shot_NumberInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plan #")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schuss #")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sparo #")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выстрелил #")
	if (locale === "es") return /** @type {LocalizedString} */ ("Disparo #")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("镜头#")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショット番号")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गोली मारना #")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tomada #")
	return /** @type {LocalizedString} */ ("Shot #")
});